import i18n from 'i18next';

export const getFieldByLangKey = (key) => {
    let lang = i18n.language === 'zh_CN'?'ci':i18n.language;
    return `${key}_${lang}`;
}

export const getproductTitle = (key, context = "product") => {
    const isChinese = i18n.language === 'zh_CN';
    
    if (context === "product") {
      // For products: use 'namecin' for Chinese and 'name' for other languages
      return isChinese ? `${key}cin` : key;
    }
    
    if (context === "category") {
      // For categories: use 'chname' for Chinese and 'name' for other languages
      return isChinese ? `ch${key}` : key;
    }
    
    // Default behavior for other contexts
    return key;
  };